var config = {
  // // OSS配置
  // region: "oss-cn-beijing",
  // accessKeyId: "LTAI5tNMaFTHoZf3kGaz3kFx",
  // accessKeySecret: "RcQqvCLKxSwcnAhDQtruStoO06Mj01",
  // bucket: "tlxia-pubgtest",
  // // OSS地址
  // imageUrl: "https://imagetest.steammm.com",
  // // AES加密
  // keyStr: "gbcdeg0922456789",
  // // UUID加密
  // hexDigits: "0123456789abcdef",
  // baseURL1: "https://apitest.steammm.com/api/index",
  // baseURL2: "https://apitest.steammm.com/api/user",
  // baseURL3: "https://downloadstest.steammm.com/api/index",

  //分站ID
  substationId: "",
  // substationId: "642fc7be2884b",

  // OSS配置
  region: "oss-cn-beijing",
  accessKeyId: "LTAI5tNMaFTHoZf3kGaz3kFx",
  accessKeySecret: "RcQqvCLKxSwcnAhDQtruStoO06Mj01",
  bucket: "tlxia-pubg",
  // OSS地址
  imageUrl: "https://image.steammm.com",
  // AES加密
  keyStr: "gbcdeg0922456789",
  // UUID加密
  hexDigits: "0123456789abcdef",
  baseURL1: "https://api.steammm.com/api/index",
  baseURL2: "https://api.steammm.com/api/user",
  baseURL3: "https://downloads.steammm.com/api/index",
};

module.exports = config;